import { Injectable, signal } from '@angular/core';
import { IUpsellEvent } from '../interfaces/upsell-event.interface';

@Injectable({
  providedIn: 'root',
})
export class UpsellService {
  private readonly eventState = signal<IUpsellEvent | null>(null);

  public readonly event = this.eventState.asReadonly();

  public trigger(event: IUpsellEvent): void {
    this.eventState.set(event);
  }

  public clear(): void {
    this.eventState.set(null);
  }
}
